import Api from "./Api";
import axios from "axios";

async function addBill(token, data,cancelToken) {

    const headers = {
        "Authorization": `Bearer ${token}`
    }
    const response = await Api.post('/api/v1/Fronts/TosanBillPayment/BillInquiry', data, {headers,cancelToken});

    return response;
}

export default addBill;